import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { Chip, CircularProgress } from "@mui/material";
import * as React from "react";

export type InvoiceStatus =
    | "draft"
    | "open"
    | "paid"
    | "uncollectible"
    | "void";

interface IOrderStatusChipProps {
    invoiceStatus: InvoiceStatus;
    invoice_id: string;
    allowStatusUpdate?: boolean;
}

export const InvoiceStatusChip = ({
    invoiceStatus,
    allowStatusUpdate = false,
}: IOrderStatusChipProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isLoading, _] = React.useState(false);

    // Menu handlers for changing order status
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLSpanElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    // Map order status to label, color, and variant for the Chip component
    const statusMap: {
        [key: string]: {
            label: "Draft" | "Open" | "Paid" | "Uncollectible" | "Void";
            color:
                | "info"
                | "success"
                | "warning"
                | "error"
                | "default"
                | "primary";
            variant: "filled" | "outlined";
            value: "draft" | "open" | "paid" | "uncollectible" | "void";
        };
    } = {
        draft: {
            label: "Draft",
            color: "warning",
            variant: "filled",
            value: "draft",
        },
        open: {
            label: "Open",
            color: "info",
            variant: "filled",
            value: "open",
        },
        paid: {
            label: "Paid",
            color: "success",
            variant: "filled",
            value: "paid",
        },
        uncollectible: {
            label: "Uncollectible",
            color: "default",
            variant: "filled",
            value: "uncollectible",
        },
        void: {
            label: "Void",
            color: "default",
            variant: "filled",
            value: "void",
        },
    };

    const status = statusMap[invoiceStatus];

    return (
        <>
            <Chip
                sx={{
                    borderRadius: ".5rem",
                    bgcolor: `${status.color}.light`,
                    p: "1px",
                    height: "auto",
                    "& .MuiChip-label": {
                        padding: "0px 8px",
                    },
                    "& .MuiChip-deleteIcon": {
                        marginRight: "0px",
                        fontSize: "22px",
                    },
                }}
                size="medium"
                label={status.label}
                color={status.color}
                variant={status.variant}
                onClick={
                    allowStatusUpdate
                        ? (event) => handleClick(event)
                        : undefined
                }
                onDelete={
                    allowStatusUpdate
                        ? (event) => handleClick(event)
                        : undefined
                }
                deleteIcon={
                    isLoading ? (
                        <CircularProgress
                            sx={{ p: 0.5 }}
                            size={20}
                            color="inherit"
                        />
                    ) : (
                        <ChevronRightRoundedIcon
                            sx={{
                                transform: open ? "rotate(90deg)" : "none",
                                transition: "transform 120ms ease-in-out",
                            }}
                        />
                    )
                }
            />
        </>
    );
};
